"use strict";

angular.module("vendor")
.service("ZoneService", function($http, appConfig) {
    this.retrieveZones = function(zonesKey) {
        return $http({
            url: appConfig.API_SERVER + "/market/locations/list/",
            method: "POST",
            headers: {"Content-Type": "application/x-www-form-urlencoded"},
            data: $.param({
                ids: zonesKey.replace(",", ";")
            })
        });
    };

    this.getIds = function(zones) {
        var zoneIds = [];
        angular.forEach(zones, function(value) {
            zoneIds.push(value.id);
        });
        return zoneIds;
    };

    this.getFilterIdParameter = function(zones) {
        return this.getIds(zones).join(",");
    };
});



//////////////////
// WEBPACK FOOTER
// ./vendor/app-core/zone/zone.service.js
// module id = 821
// module chunks = 0